module.exports = __webpack_public_path__ + "static/media/pedra2.afb67f35.jpg";